IntlMessageFormat.__addLocaleData({"locale":"ug","pluralRuleFunction":function (n,ord){if(ord)return"other";return n==1?"one":"other"}});
IntlMessageFormat.__addLocaleData({"locale":"ug-Arab","parentLocale":"ug"});
IntlMessageFormat.__addLocaleData({"locale":"ug-Arab-CN","parentLocale":"ug-Arab"});
